import { useTranslation } from 'react-i18next';

import './SearchBox.scss';

const SearchBox = (props) => {
  const { t } = useTranslation();

  return (
    <div className='search-container'>
        <input type="text" id="search-bar" placeholder={ t("LT_search")} />
        <i className="fa fa-search search-container-icon" aria-hidden="true"></i>
    </div>
  )
}

export default SearchBox;